(function () {
  'use strict';

  var affirmLoad = null;

  function affirmReady() {
    return !!(window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function');
  }

  // Load Affirm.js once per page. Resolves when the script is present and
  // window.affirm is available. If the Affirm app already loaded it, resolve
  // immediately. Uses the script's load event (no polling).
  function ensureAffirm(key, src) {
    if (window.affirm) {
      return Promise.resolve();
    }
    if (affirmLoad) {
      return affirmLoad;
    }
    if (!key || !src) {
      return Promise.reject(new Error('affirm: missing public key or script URL'));
    }
    affirmLoad = new Promise(function (resolve, reject) {
      if (!window._affirm_config) {
        window._affirm_config = {
          public_api_key: key,
          script: src,
          locale: 'en_US',
          country_code: 'USA'
        };
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.addEventListener('load', function () { resolve(); });
      s.addEventListener('error', function () { reject(new Error('affirm: failed to load ' + src)); });
      document.head.appendChild(s);
    });
    return affirmLoad;
  }

  function refresh() {
    if (affirmReady() && typeof window.affirm.ui.refresh === 'function') {
      try {
        window.affirm.ui.ready(function () {
          window.affirm.ui.refresh();
        });
      } catch (err) {
        console.error('affirm: refresh failed', err);
      }
    }
  }

  class AffirmPaymentExample extends HTMLElement {
    connectedCallback() {
      if (this._initialized) {
        refresh();
        return;
      }
      this._initialized = true;
      this._onSectionLoad = this.onSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionLoad);

      ensureAffirm((this.dataset.publicKey || '').trim(), this.dataset.scriptUrl || '')
        .then(refresh)
        .catch(function () { /* no key / blocked / offline — static fine print remains */ });
    }

    disconnectedCallback() {
      if (this._onSectionLoad) {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
      }
    }

    onSectionLoad(event) {
      if (event.target instanceof Element && event.target.contains(this)) {
        refresh();
      }
    }
  }

  if (!customElements.get('affirm-payment-example')) {
    customElements.define('affirm-payment-example', AffirmPaymentExample);
  }
})();
